/**
 * 中国直达订单 | 中国直发订单
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import {Tabs, Spin, Space, Badge,  Tooltip,} from "antd";
import {symbolMoneyUtil} from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
import {Link} from "react-router-dom";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@/components/Lang/Lang";
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import dayjs from 'dayjs';
import ModalOrderDetail from "@components/ModalOrderDetails/ModalOrderDetail";
import ModalCancelProduct from "./components/ModalCancelProduct/ModalCancelProduct";
import ModalConfirmPayment from "./components/ModalConfirmPayment"
import "./OrderDirectSale.less";

class OrderDirectSale extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            //
            tabKay: '1',//	列表页签 1:待提货 2:需送车 3:已提货
            // 搜索默认 10:客户编码 20:联系人名称 30:联系人电话
            sKeywordType: "10",
            // 搜索配置
            searchFormOptionsOne:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'times',
                    // cnTitle:'注册时间',
                    // cnTitleId:'ZhuCeShiJian',
                    type:'DateRangePicker',
                    // cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    // cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['createTimeStart','createTimeEnd'],
                },
                {
                    name:'poCode',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'订单编号',
                    cnPlaceholderId:'DingDanBianHao',
                    width:216,
                },
                {
                    name:'buyerCode',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索客户编号或名称',
                    cnPlaceholderId:'SouSuoKeHuBianHaoHuoMinCheng',
                    width:216,
                },
            ],
            columns:[
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    width: 150,
                    dataIndex: 'buyerCode', // buyerCode
                    render:(buyerCode, record={}, index) => (<div>
                        {record.buyerId?<Link className="color-blue"
                                             target={"_blank"}
                                             to={`/customer/detail?id=${record.buyerId}`}>{buyerCode}</Link>:buyerCode}
                        {record.submitChinaOrder==1?<div className={"black66 font_12"}>
                            {Lang({id:"KeHuYaoQiuZhiFa",default:"客户要求直发"})}
                        </div>:null}
                    </div>),
                },
                {
                    cnTitle: 'PO订单',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODingDan',
                    width:200,
                    render:(poCode, record, index) => (<>
                        <p>
                            <ModalOrderDetail id={record.poId}>
                                <span className={"fw_700 black89 cursor-p"}>{poCode}</span>
                            </ModalOrderDetail>
                        </p>
                        <p>
                            {Lang({id:"NKuanNXiang",default:"{0} 款，{1} 箱",params:[record.itemCount,record.totalQuantity]})}
                        </p>
                        <p className={"black45"}>
                            <Tooltip placement="right" title={Lang({id:"ChuangJianShiJian", default:"创建时间"})}>
                                <span className={"ri-time-line"} />
                                <span className={"font_12 ml_4"}>{record.createTime? dayjs(record.createTime).format("YYYY-MM-DD"): "-"}</span>
                            </Tooltip>
                        </p>

                    </>)
                },
                {
                    cnTitle: '订单金额',
                    dataIndex: 'totalPrice',
                    cnTitleId: 'DingDanJinE',
                    render:(text, record, index) => (
                        <p className={"fw_700"}>
                            {symbolMoneyUtil(record.totalPrice, record.currencySymbol)}
                        </p>
                    ),
                    width:150,
                },
                {
                    cnTitle: '收货人信息³',
                    dataIndex: 'consignee',
                    cnTitleId: 'ShouHuoRen',
                    width:300,
                    render:(text, record, index) => (
                        <Space direction="vertical ">
                            <div>{record.consigneeName}</div>
                            <div className="black45">{record.consigneeMonde}</div>
                        </Space>
                    )
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                },

                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 120,
                    fixed:'right',
                    // align:"right",
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<>
                        <ModalCancelProduct id={record.poId}
                                            refreshPage={()=>this.refreshPage(this.state.currPage)} />
                        <span className={"ml_8"}>
                             <ModalConfirmPayment item={record}
                                                  refreshPage={()=>this.refreshPage(this.state.currPage)} />
                        </span>
                    </>)},
            ],
            // 待支付搜索配置
            searchFormOptionsWaitPay:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'poCode',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'订单编号',
                    cnPlaceholderId:'DingDanBianHao',
                    width:216,
                },
                {
                    name:'buyerCode',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索客户编号或名称',
                    cnPlaceholderId:'SouSuoKeHuBianHaoHuoMinCheng',
                    width:216,
                },
            ],
            columnsWaitPay:[
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    width: 150,
                    dataIndex: 'buyerCode', // buyerCode
                    render:(buyerCode, record, index) => (<div>
                        {record.buyerId?<Link className="color-blue"
                                             target={"_blank"}
                                             to={`/customer/detail?id=${record.buyerId}`}>{buyerCode}</Link>:buyerCode}
                        {record.submitChinaOrder==1?<div className={"black66 font_12"}>
                            {Lang({id:"KeHuYaoQiuZhiFa",default:"客户要求直发"})}
                        </div>:null}
                    </div>),
                },
                {
                    cnTitle: 'PO订单',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODingDan',
                    width:200,
                    render:(poCode, record, index) => (<>
                        <p>
                            <ModalOrderDetail id={record.poId}>
                                <span className={"fw_700 black89 cursor-p"}>{poCode}</span>
                            </ModalOrderDetail>
                        </p>
                        <p className={"mt_4 mb_4"}>
                            {Lang({id:"NKuanNXiang",default:"{0} 款，{1} 箱",params:[record.itemCount,record.totalQuantity]})}
                        </p>
                        {/* 定金支付状态 | 尾款支付状态*/}
                        {record.depositPayStatus=="TO_BE_CONFIRM"?<span className={`labelStatus labelStatusRed`}>
                          {Lang({id:"DaiZhiFuDingJin",default:"待支付定金"})}
                        </span>:(record.balancePayStatus=="TO_BE_CONFIRM"?<span className={`labelStatus labelStatusRed`}>
                          {Lang({id:"DaiZhiFuWeiKuan",default:"待支付尾款"})}
                        </span>:null)}
                    </>)
                },
                {
                    cnTitle: '订单金额',
                    dataIndex: 'totalPrice',
                    cnTitleId: 'DingDanJinE',
                    render:(text, record, index) => (
                        <>
                            <div className={"black66 fw_700 font_14"}>
                                {symbolMoneyUtil(record.totalPrice, record.currencySymbol)}
                            </div>
                            {record.deposit?<Tooltip placement="right" title={Lang({id:"DingJin", default:"定金"})}>
                            <span className={"black45 font_12"}><i className={"ri-dual-sim-1-fill mr_4 font_14"} />
                                {symbolMoneyUtil(record.deposit, record.currencySymbol)}
                            </span>
                            </Tooltip>:null}
                            {record.balance?<div className={"black45 font_12"}>
                                <Tooltip placement="right" title={Lang({id:"WeiKuan", default:"尾款"})}>
                                <span><i className={"ri-dual-sim-2-fill mr_4 font_14"} />
                                    {symbolMoneyUtil(record.balance, record.currencySymbol)}
                                </span>
                                </Tooltip>
                            </div>:null}
                        </>

                    ),
                    width:150,
                },
                {
                    cnTitle: '收货人信息³',
                    dataIndex: 'consignee',
                    cnTitleId: 'ShouHuoRen',
                    width:300,
                    render:(text, record, index) => (
                        <Space direction="vertical ">
                            <div>{record.consigneeName}</div>
                            <div className="black45">{record.consigneeMonde}</div>
                        </Space>
                    )
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                },
                {
                    cnTitle: '确定时间',
                    cnTitleId: 'QueDingShiJian',
                    dataIndex: 'confirmTime',
                    render: (confirmTime, record, index) => (
                        <div key={index}>
                            <p>{confirmTime? dayjs(confirmTime).format("YYYY-MM-DD"): "-"}</p>
                            <p className={"black45 font_12"}>{record.confirmUserName}</p>
                            {record.confirmDays>0?<div className={"color-red2 font_12"}>{Lang({id:"YiGuoNTian",default:`已过 ${record.confirmDays}天`,params:[record.confirmDays]})}</div>:null}
                        </div>
                    ),
                },  {
                    cnTitle: '支付信息',
                    cnTitleId: 'ZhiFuXinXi',
                    dataIndex: 'payTypeName',
                    render:(payTypeName, record, index) => (
                        <Space direction="vertical ">
                            <div>{payTypeName}</div>
                            {/* 支付方式;现金:cash,汇款:remittance */}
                            {record.payType="remittance"?<div className="black45">{record.bankCardNo}</div>:null}
                        </Space>
                    )
                },

            ],
            columnsCancel:[
                {
                    cnTitle: '客户编号',
                    cnTitleId: 'KeHuBianHao',
                    width: 150,
                    dataIndex: 'buyerCode', // buyerCode
                    render:(buyerCode, record, index) => (<div>
                        {record.buyerId?<Link className="color-blue"
                                             target={"_blank"}
                                             to={`/customer/detail?id=${record.buyerId}`}>{buyerCode}</Link>:buyerCode}
                        {record.submitChinaOrder==1?<div className={"black66 font_12"}>
                            {Lang({id:"KeHuYaoQiuZhiFa",default:"客户要求直发"})}
                        </div>:null}
                    </div>),
                },
                {
                    cnTitle: 'PO订单',
                    dataIndex: 'poCode',
                    cnTitleId: 'PODingDan',
                    width:200,
                    render:(poCode, record, index) => (<>
                        <p>
                            <Link to={`/order/sale/detail?id=${record.poId}`} className={"fw_700 black89"} target={"_blank"}>{poCode}</Link>
                                {/*<span className={"fw_700 black89 cursor-p"}>{poCode}</span> */}
                        </p>
                        <p className={"mt_4 mb_4"}>
                            {Lang({id:"NKuanNXiang",default:"{0} 款，{1} 箱",params:[record.itemCount,record.totalQuantity]})}
                        </p>
                    </>)
                },
                // {
                //     cnTitle: '订单金额',
                //     dataIndex: 'totalPrice',
                //     cnTitleId: 'DingDanJinE',
                //     render:(text, record, index) => (
                //         <>
                //             <div className={"black66 fw_700 font_14"}>
                //                 {symbolMoneyUtil(record.totalPrice, record.currencySymbol)}
                //             </div>
                //             {record.deposit?<Tooltip placement="right" title={Lang({id:"DingJin", default:"定金"})}>
                //             <span className={"black45 font_12"}><i className={"ri-dual-sim-1-fill mr_4 font_14"} />
                //                 {symbolMoneyUtil(record.deposit, record.currencySymbol)}
                //             </span>
                //             </Tooltip>:null}
                //             {record.balance?<div className={"black45 font_12"}>
                //                 <Tooltip placement="right" title={Lang({id:"WeiKuan", default:"尾款"})}>
                //                 <span><i className={"ri-dual-sim-2-fill mr_4 font_14"} />
                //                     {symbolMoneyUtil(record.balance, record.currencySymbol)}
                //                 </span>
                //                 </Tooltip>
                //             </div>:null}
                //         </>
                //
                //     ),
                //     width:150,
                // },
                {
                    cnTitle: '收货人信息³',
                    dataIndex: 'consignee',
                    cnTitleId: 'ShouHuoRen',
                    width:300,
                    render:(text, record, index) => (
                        <Space direction="vertical ">
                            <div>{record.consigneeName}</div>
                            <div className="black45">{record.consigneeMonde}</div>
                        </Space>
                    )
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                    width:200,
                },
                {
                    cnTitle: '取消时间',
                    cnTitleId: 'QuXiaoShiJian',
                    dataIndex: 'lastUpdateTime',
                    render: (lastUpdateTime, record, index) => (
                        <div key={index}>
                            <p>{lastUpdateTime? dayjs(lastUpdateTime).format("YYYY-MM-DD"): "-"}</p>
                        </div>
                    ),
                },

            ],
            tabStatus:'1',//默认 1:待确认 2:待支付 3. 已取消
            total: 0,
        }
    }
    /**
     * 改变状态
     **/
    changeTab(activeKey){
        this.setState({
            tabStatus:activeKey
        },()=>{
            switch (activeKey) { // 已加载组件 更新点击项 时 重新搜索内容
                case '3':
                   if(this.onRefChildCancleTab){
                       this.onRefChildCancleTab.handleFetch(1,{},true);
                   }
                   break
                case '2':
                    if(this.onRefTabChildTwo){
                        this.onRefTabChildTwo.handleFetch(1,{},true);
                    }
                    break
                default:
                    if(this.onRefTabChildOne){
                        this.onRefTabChildOne.handleFetch(1,{},true);
                    }
            }
        })
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    onRefTabTwo = (ref) =>  this.onRefTabChildTwo = ref;
    onRefCancelTab = (ref) =>  this.onRefChildCancleTab = ref;
    //
    refreshPage(currPage=1){
        const { tabKay } = this.state;
        switch (tabKay) {
            case "1":
                this.onRefTabChildOne.handleFetch(currPage,{},true);
                return
            case "2":
                this.onRefTabChildTwo.handleFetch(currPage,{},true)
                return
            default:
                this.onRefChildCancleTab.handleFetch(currPage,{},true)
                return;
        }
    }
    /**
     * 重置
     * */
    searchReset(){
        this.setState({
            sKeyword:"",
            sKeywordType: "10",
        },()=>this.onRefTabChildOne.handleFetch(1,{},false))
    }
    // // 赋值
    // setInputKey(key,str){
    //     let curr = this.state;
    //     curr[key] = str;
    //     this.setState(curr)
    // }
    // 查询回调
    changeNum(waitConfirmNum=0,waitPayNum=0){
        this.setState({
            waitConfirmNum: waitConfirmNum,
            waitPayNum: waitPayNum,
        } )
    };
    fetchCallBack(res={}){
        const { model ={}, paging={}} = res;
        this.changeNum(model.waitConfirmNum,model.waitPayNum)
        this.setState({
            currPage:paging.pageNum || 1
        })
        this.onRefPageCommonChild.isShowTop();
    }
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    componentDidMount() {}
    componentWillMount() {

    }
    render(){
        const { loading,searchFormOptionsOne,columns,tabStatus,columnsWaitPay, searchFormOptionsWaitPay,columnsCancel} = this.state;
        const currPageName = Lang({id: "ZhongGuoZhiFaDingDan",default: "中国直发订单"});
        return (
            <PageCommon onRef={this.onRefPageCommon}>
                <Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                <div className="dataStatistics-sale">
                    <Tabs defaultActiveKey={tabStatus}
                          onChange={(activeKey)=>this.changeTab(activeKey)}
                          items={[
                              {
                                  key: '1',
                                  label:<span>
                                      {Lang({id: 'DaiQueRen1', default: '待确认'})}
                                      <Badge count={this.state.waitConfirmNum}></Badge>
                                  </span>,
                                  // label:(<div>
                                  //     <span className="mr_4">{Lang({id: 'DaiQueRen1', default: '待确认'})}</span>
                                  //     <Badge count={this.state.waitConfirmNum||16}></Badge>
                                  // </div>),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columns}
                                                      rowKey={'poId'}
                                                      onRef={this.onRefTabOne}
                                                      fetchCallBack={(data)=>this.fetchCallBack(data)}
                                                      // flagShowReset={false}
                                                      scroll={{x:1200,}}
                                                      // pageSize={50}
                                                      searchFormOptions={searchFormOptionsOne}
                                                      precondition={{
                                                          type:Number(tabStatus),//1:待确认 2:待支付 3:已取消
                                                      }}
                                                      fetchApi={'/service/mg/statistics/sale-data-china'}>
                                      </AutoFetchTable>
                                  </div>)
                              },{
                                  key: '2',
                                  label:<span>
                                      {Lang({id: 'DaiFuKuan', default: '待支付'})}
                                      <Badge count={this.state.waitPayNum}></Badge>
                                  </span>,
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columnsWaitPay}
                                                      rowKey={'poId'}
                                                      onRef={this.onRefTabTwo}
                                                      fetchCallBack={(data)=>this.fetchCallBack(data)}
                                                      scroll={{x:1200,}}
                                          // pageSize={50}
                                                      searchFormOptions={searchFormOptionsWaitPay}
                                                      precondition={{
                                                          type:Number(tabStatus),//1:待确认 2:待支付 3:已取消
                                                      }}
                                                      fetchApi={'/service/mg/statistics/sale-data-china'}>
                                      </AutoFetchTable>
                                  </div>)
                              },{
                                  key: '3',
                                  label:Lang({id: 'YiQuXiao', default: '已取消'}),
                                  children:(<div className={'content'}>
                                      <AutoFetchTable columns={columnsCancel}
                                                      rowKey={'poId'}
                                                      onRef={this.onRefCancelTab}
                                                      fetchCallBack={(data)=>this.fetchCallBack(data)}
                                          // pageSize={50}
                                                      searchFormOptions={searchFormOptionsOne}
                                                      precondition={{
                                                          type:Number(tabStatus),//1:待确认 2:待支付 3:已取消
                                                      }}
                                                      fetchApi={'/service/mg/statistics/sale-data-china'}>
                                      </AutoFetchTable>
                                  </div>)
                              }
                          ]}
                    >
                    </Tabs>
                </div>
            </Spin>
        </PageCommon>)
    }
}

export default OrderDirectSale;
